import { Component } from 'react';

import PaymentMethod  from '@/lib/domain/payments/payment-method';
import { getCurrencyCode } from '@/lib/locale';
import CenterLoader from '@/shared/ui/layout/center-loader';

import { AppData } from '../../index';

import AutoTopupSettingsForm from './auto-topup-settings-form';
import PaymentForm from './payment-form';
import PaymentInfo from './payment-info';
import PaymentPointsView from './payment-points-view';

type MainState = {
    loading: boolean;
    amount: string;
    selectedMethod: PaymentMethod<any> | null;
    selectedMethodIndex: number | null;
    showAutoTopupView: boolean;
    mapSrcToShow?: string;
    hideGoBack: boolean;
}

class Main extends Component<AppData, MainState> {
    constructor(props: AppData) {
        super(props);

        this.state = {
            loading: false,
            amount: '',
            selectedMethodIndex: this.props.paymentInfo.defaultMethod,
            selectedMethod: null,
            showAutoTopupView: false,
            mapSrcToShow: undefined,
            hideGoBack: false,
        };
    }

    public componentDidMount = () => {
        window.access('mainviewmounted');

        this.props.services.paymentInfoService.onShowPaymentInfo(() => {
            this.resetSelectedMethod();
        });

        this.props.services.navigatorService.onNativeBackArrowClick(this.handleGoBack);
    };

    private handleSelectedMethodIndexChange = (selectedMethodIndex: number | null) => {
        this.setState({ selectedMethodIndex });
    };

    private handleGoBack = () => {
        this.props.services.navigatorService.hideNativeBackArrow();

        this.setState({
            mapSrcToShow: '',
            selectedMethod: null,
            showAutoTopupView: false,
            hideGoBack: false,
        });
    };

    /** @deprecated */
    private handleHideGoBack = () => {
        this.setState({
            hideGoBack: true,
        });
    };

    private resetSelectedMethod = () => {
        this.setState({
            selectedMethod: null,
        });
    };

    private handlePaymentMethod = (amount: string, selectedMethod: PaymentMethod<any>) => {
        const { analyticService, viewService } = this.props.services;

        analyticService.event('processing.topup_payment_option.click', {
            payment_option: selectedMethod.getPaymentType(),
            provider: selectedMethod.providerName,
        });

        if (viewService.isOneStepMethod(selectedMethod)) {
            return;
        }

        if (selectedMethod.isOneClickPayForm()) {
            this.setState({ loading: true });
            this.props.services.topupService.topUp(
                amount,
                selectedMethod,
                {},
                this.props.paymentInfo.country,
            );

            return;
        }

        // it means redirect to payment form
        this.setState({
            amount,
            selectedMethod,
        });
    };

    private handleAutoTopupShow = () => {
        this.props.services.analyticService.event('processing.topup_pay_auto.click', undefined);

        this.setState({ showAutoTopupView: true });
    };

    private handlePaymentPointsClick = (mapSrcToShow: string) => {
        this.setState({ mapSrcToShow });
    };

    public render() {
        const { amount, selectedMethod } = this.state;
        const { paymentInfo, services } = this.props;

        if (this.state.loading) {
            return <CenterLoader loading />;
        }

        if (this.state.showAutoTopupView) {
            return (
                <AutoTopupSettingsForm
                    country={paymentInfo.country}
                    autoTopupInfo={paymentInfo.autoTopup}
                    currencyCode={getCurrencyCode(paymentInfo.country)}
                    services={services}
                    onGoBack={this.handleGoBack}
                />
            );
        }

        if (this.state.mapSrcToShow) {
            return (
                <PaymentPointsView
                    src={this.state.mapSrcToShow}
                    onGoBack={this.handleGoBack}
                />
            );
        }

        if (selectedMethod) {
            return (
                <PaymentForm
                    amount={amount}
                    method={selectedMethod}
                    paymentInfo={this.props.paymentInfo}
                    services={this.props.services}
                    hideGoBack={this.state.hideGoBack}
                    onGoBack={this.handleGoBack}
                    onHideGoBack={this.handleHideGoBack}
                />
            );
        }

        return (
            <PaymentInfo
                defaultAmount={paymentInfo.defaultAmount}
                selectedMethodIndex={this.state.selectedMethodIndex}
                country={paymentInfo.country}
                currencyCode={getCurrencyCode(paymentInfo.country)}
                paymentMethods={paymentInfo.paymentMethods}
                autoTopupInfo={paymentInfo.autoTopup}
                suggestedAmountsView={paymentInfo.suggestedAmountsView}
                services={services}
                onSelectedMethodIndexChange={this.handleSelectedMethodIndexChange}
                onPaymentMethod={this.handlePaymentMethod}
                onAutoTopupClick={this.handleAutoTopupShow}
                onPaymentPointsClick={this.handlePaymentPointsClick}
            />
        );
    }
}

export default Main;
